import { Link, useLocation } from "react-router-dom";
import { isaddQuizSelected, isQuizSelected } from "utils/checkRouter";
import { useNavigate } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { MainContext } from "utils/context";
import { signOutUser, fetchTabsFromDatabase } from "utils/firebaseFunction";
import { FaChevronDown } from "react-icons/fa";

export default function DesktopMenu() {
  const { user, isAdmin, loading, userId, selectedTab, setSelectedTab } = useContext(MainContext);
  const loc = useLocation();
  const navigate = useNavigate();
  
  const [tabs, setTabs] = useState([]);
  const [error, setError] = useState("");
  const [isSelectOpen, setIsSelectOpen] = useState(false);

  // جلب التصنيفات عند تحميل المكون
  useEffect(() => {
    const fetchTabs = async () => {
      try {
        const fetchedTabs = await fetchTabsFromDatabase();
        setTabs(fetchedTabs);
      } catch (error) {
        console.error("Error fetching tabs:", error);
        setError("Failed to load categories");
      }
    };

    fetchTabs();
  }, []);

  const handleSignOut = async () => {
    try {
      const res = await signOutUser();
      if (res.success) {
        window.location.reload();
      } else {
        setError("Failed to sign out");
      }
    } catch (error) {
      setError("An error occurred while signing out");
    }
  };

  return (
    <>
      {/* إظهار السيلكت فقط في الصفحة الرئيسية */}
      {loc.pathname === "/" && (
        <div className="navbar__filters">
          <div className={`custom-select ${isSelectOpen ? 'open' : ''}`}>
            <select
              value={selectedTab}
              onChange={(e) => setSelectedTab(e.target.value)}
              className="select-input"
              onFocus={() => setIsSelectOpen(true)}
              onBlur={() => setIsSelectOpen(false)}
            >
              <option value="">All Quiz</option>
              {tabs.map((tab, index) => (
                <option key={index} value={tab}>
                  {tab}
                </option>
              ))}
            </select>
            <FaChevronDown className={`select-arrow ${isSelectOpen ? 'open' : ''}`} />
          </div>
        </div>
      )}

      {/* القائمة الأصلية */}
      <Link
        to={"/"}
        className={`navbar__right-side__item ${isQuizSelected(loc.pathname) && "navbar__right-side__item--selected"}`}
      >
        Quiz
      </Link>

      {isAdmin && (
        <Link
          to={"/addQuiz"}
          className={`navbar__right-side__item ${isaddQuizSelected(loc.pathname) && "navbar__right-side__item--selected"}`}
        >
          Add Quiz
        </Link>
      )}

      {isAdmin && userId === "JuAxp52a7uMSF7vrzwxKVpIN6Nw2" && (
        <Link
          to={"/admin"}
          className={`navbar__right-side__item ${loc.pathname === "/admin" && "navbar__right-side__item--selected"}`}
        >
          Admin
        </Link>
      )}

      {loading ? (
        <div className="loading-spinner" />
      ) : user ? (
        <button className="navbar__right-side__btn Btn" onClick={handleSignOut}>
          Sign Out
        </button>
      ) : (
        <button
          className="navbar__right-side__btn Btn"
          onClick={() => navigate("/authenticate")}
        >
          Login
        </button>
      )}

      {error && <div className="error-message">{error}</div>}
    </>
  );
}